export default {
    // root: {
    //     color: "white"
    // }
};
